/**
 * Stands in for a chat participant whose account was deleted. The API sends that participant as null.
 * The photo is the same default avatar the API returns for users without a photo.
 */
export const DELETED_CHAT_USER = Object.freeze({
    id: null,
    name: 'Deleted user',
    photo_url: '/img/default-avatar.png',
});
